module.exports = "pegasus/assets/two-column-image-text-preview.png";